import OrganizationChart from '@dabeng/react-orgchart';
import clsx from 'clsx';

import { Node } from './Node';
import { IOrganizationalStructureProps } from './types';
import { getStyles, prepareDataSource } from './utils';

export const OrganizationalStructure = ({
  data: { level1Department, level2Department, level3Department },
}: IOrganizationalStructureProps) => {
  const styles = getStyles();
  const dataSource = prepareDataSource({
    id: 'ceo',
    name: level1Department,
    isFirst: true,
    children: level2Department.map(({ department }, index) => {
      const children = level3Department
        .filter(({ belowDepartment }) => belowDepartment === department)
        .map(({ department }, index) => ({
          id: index,
          name: department,
        }));

      return {
        id: index,
        name: department,
        isLast: !!children.length,
        children,
      };
    }),
  });

  return (
    <OrganizationChart
      datasource={dataSource}
      draggable={false}
      NodeTemplate={Node}
      multipleSelect={false}
      collapsible={false}
      containerClass={clsx(styles.wrapper, { [styles.single]: dataSource.children?.length === 1 })}
    />
  );
};
